// Define the expected structure
const expectedStructure = {
  classlist: '',
  url: '',
  buyercallinputs: {
    firstName: '',
    lastName: '',
    Source: '',
    state: '',
  },
  customerdetails: {
    customerName: '',
    inventoryLink: '',
    openHours: '',
    phoneNumber: '',
    privacyPolicyLink: '',
    termsLink: '',
  },
  title: '',
  subtitle: '',
  'button-img-url': '',
  colorprimary: '',
  colorsecondary: '',
  infosectionbackground: '',
  buttonprimary: '',
  buttonsecondary: '',
  formLogo: '',
  submitButtonText: '',
  inventoryLinkText: '',
  mainmessage: '',
  lowestonly: '',
  additionalParams: '',
  pic: '',
  dcv: '',
  rpl: '',
  formid: '',
  template: '',
  disclaimer: '',
  NoPaymentSuccessMessage: '',
  apiparam: '',
  gtmid: '',
};

const validateConfigData = (jsonData) => {
  const result = validateAndCleanJson(jsonData, expectedStructure);
  if (result.isValid) {
    return result.cleanedData;
  } else {
    return '';
  }
};

const isObject = (value) =>
  value && typeof value === 'object' && !Array.isArray(value);

const validateAndCleanJson = (data, structure) => {
  let parsedData;

  try {
    if (isObject(data)) {
      parsedData = data;
    } else {
      parsedData = JSON.parse(data);
    }
  } catch (e) {
    return { isValid: false, cleanedData: null };
  }

  for (let key in parsedData.sites) {
    if (!validateAndCleanSingle(parsedData.sites[key], structure)) {
      return { isValid: false, cleanedData: null };
    }
  }

  return { isValid: true, cleanedData: { ...parsedData } };
};

function validateAndCleanSingle(obj, struct) {
  // Remove extra keys
  for (let key in obj) {
    if (!(key in struct)) {
      delete obj[key];
    }
  }

  // Validate and clean existing keys
  for (let key in struct) {
    if (key in obj) {
      if (typeof struct[key] === 'object' && struct[key] !== null) {
        if (typeof obj[key] !== 'object' || obj[key] === null) {
          return false;
        }
        if (!validateAndCleanSingle(obj[key], struct[key])) {
          return false;
        }
      } else if (typeof obj[key] !== typeof struct[key]) {
        return false;
      }
    } else {
      return false;
    }
  }
  return true;
}

export default validateConfigData;
